import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFieldMask',
})
export class NumberFieldMaskPipe implements PipeTransform {
  transform(useCommaSeparator: boolean, digitsCount: number): string {
    if (useCommaSeparator) {
      return `separator.${digitsCount ? digitsCount : ''}`;
    }

    return `0*${this.digitsMask(digitsCount)}`;
  }

  private digitsMask(digitsCount: number): string {
    if (!digitsCount) {
      return '';
    }

    let result: string = '';
    for (let i: number = 0; i < digitsCount; i++) {
      result += '0';
    }
    return `.${result}`;
  }
}
